import './layout.constructor.styles.scss'
interface MyProps { }

export default function LayoutConstructorComponent(props: React.PropsWithChildren<MyProps>) {

    return <div className='LayoutConstructorComponent'>
        {props.children}
    </div>

}